import { connect } from 'react-redux';
import { logout } from '../../../screens/Login/actions';
import { resetMonitorView } from '../../../screens/PlazaView/actions';
import { resetToInitialState } from '../../../screens/PlazaView/components/Editor/actions';
import Navbar from './Navbar';

const mapStateToProps = (state) => ({
  isAuthenticated: state.login.isAuthenticated,
  user: state.login.user,
  config: state.appConfig.config,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => {
    dispatch(resetToInitialState());
    dispatch(resetMonitorView());
    dispatch(logout());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
